import LegacyArrayView from "./LegacyArrayView";
export default LegacyArrayView;
